console.log("theme.defer.final.js loaded");

let CountdownTimer = class CountdownTimer extends HTMLElement {
  connectedCallback() {
    if (isNaN(this.endDate)) {
      this.onComplete();
      return;
    }
    // Add additional logic here if needed
  }
};

let RecordRecentlyViewed = class RecordRecentlyViewed {
  updateCookie() {
    let recentlyViewed = this.cookie.read();
    const position = recentlyViewed.indexOf(this.handle);
    if (position === -1) {
      recentlyViewed.unshift(this.handle);
      recentlyViewed = recentlyViewed.splice(0, config.howManyToStoreInMemory);
    }
    // Add additional logic here if needed
  }
};

let RecentProducts = class RecentProducts {
  renderProducts() {
    const recentlyViewedHandlesArray = this.cookie.read();
    const arrayURLs = [];
    let counter = 0;
    if (recentlyViewedHandlesArray.length > 0) {
      for (let index = 0; index < recentlyViewedHandlesArray.length; index++) {
        const handle = recentlyViewedHandlesArray[index];
        if (excludedHandles.includes(handle)) {
          continue;
        }
        // Add product loading logic here if needed
      }
    }
  }
};

let RadioSwatch = class RadioSwatch extends HTMLElement {
  init() {
    this.setStyles();
    if (this.variant && this.outer) {
      this.outer.addEventListener('theme:quickview:media', (e) => {
        if (e && e.detail && e.detail.media) {
          this.media = e.detail.media;
        }
      });
    }
  }
};

let GridSwatch = class GridSwatch {
  init() {
    this.wrap.innerHTML = '';
    this.swatches.forEach((swatch, index) => {
      let variant1 = this.product.variants.find((variant) => {
        return variant.options.includes(swatch);
      });
      // Add more logic here if needed
    });
  }
};

function makeGridSwatches(container) {
  const gridSwatchWrappers = container.querySelectorAll(selectors$12.wrapper);
  gridSwatchWrappers.forEach((wrap) => {
    new GridSwatch(wrap);
  });
}
